import { render, staticRenderFns } from "./UmyMessage.vue?vue&type=template&id=2ac984cd&scoped=true&"
import script from "./UmyMessage.vue?vue&type=script&lang=js&"
export * from "./UmyMessage.vue?vue&type=script&lang=js&"
import style0 from "./UmyMessage.vue?vue&type=style&index=0&id=2ac984cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac984cd",
  null
  
)

export default component.exports